<template>
  <v-container>
    <div
      :style="{ backgroundImage: 'url(/images/home-banner.png)' }"
      class="general-slide"
    >
      <v-container class="pa-2">
        <v-row class="fill-height">
          <v-col
            cols="8"
            md="6"
            class="right-fade-bg d-flex justify-center align-center"
          >
            <div>
              <h1 class="mb-2 text-h2">
                {{ pkg.project }}
              </h1>
              <ul class="body-1 pt-2 pb-2 no-bullets">
                <li class="mt-4">
                  <h4 class="text-h4">
                    {{ t('home.line_1_title') }}
                  </h4>
                  <p class="text-secondary">
                    {{ t('home.line_1_subtitle') }}
                  </p>
                </li>
                <li class="mt-6">
                  <h4 class="text-h4">
                    {{ t('home.line_2_title') }}
                  </h4>
                  <p class="text-secondary">
                    {{ t('home.line_2_subtitle') }}
                  </p>
                </li>
                <li class="mt-6">
                  <h4 class="text-h4">
                    {{ t('home.line_3_title') }}
                  </h4>
                  <p class="text-secondary">
                    {{ t('home.line_3_subtitle') }}
                  </p>
                </li>
                <li class="mt-6">
                  <h4 class="text-h4">
                    {{ t('home.line_4_title') }}
                  </h4>
                  <p class="text-secondary">
                    {{ t('home.line_4_subtitle') }}
                  </p>
                </li>
              </ul>
              <v-btn
                size="x-large"
                elevation="2"
                color="primary"
                class="mt-6"
                to="/sign-in"
              >
                {{ t('home.start_btn') }}
              </v-btn>
            </div>
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

import pkg from '../../../package.json';

const {t} = useI18n();
</script>

<script lang="ts">
export default {
  name: 'Home',
};
</script>